import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BaseRequestService } from 'app/_services/base.service';
import { CommonService } from 'app/_services/common.services';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { ChangeDetectorRef } from '@angular/core';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

// vfs_fonts exports the vfs object directly (default or module); pdfMake 0.2.x had pdfMake.vfs
const vfs = (pdfFonts as any).default ?? (pdfFonts as any).pdfMake?.vfs ?? (pdfFonts as any);
if (vfs && typeof (pdfMake as any).addVirtualFileSystem === 'function') {
  (pdfMake as any).addVirtualFileSystem(vfs);
} else if (vfs) {
  (pdfMake as any).vfs = vfs;
}

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  // reportslist:any=[];
  roData: any = {};
  currentreport: any = {};
  codeh: any = [];
  codei: any = []
  public rolist = this.codeh.slice();
  public reportslist = this.codei.slice();
  loadingreports: boolean = false;
  load: boolean = false
  urlSafe1: any = ''
  userrole: any = ''
  show: any;
  product: any;
  startDateMoment: string | null = null;
  dsrmonth: string | null = null;
  isChildHidden = false;
  constructor(private cds: ChangeDetectorRef, private cs: CommonService, private httpClient: HttpClient, private baseService: BaseRequestService, private sanitizer: DomSanitizer) {
    this.cs.current({ 'tab': 'REPORTS', 'count': 0, 'showcount': true })
    this.show = this.cs.reportsShow;
    this.cs.downloadtrigger.subscribe((data: any) => {
      this.downloadDivAsPdf()
    })
    this.cs.currentalerts.subscribe(value => {
      this.cs.reportsShow = value;
      this.show = value
      this.triggerview();
      this.cds.markForCheck()
    })

    this.cs.startDate$.subscribe((date) => {
      if (date) {
        this.startDateMoment = date;
      }
    });
    this.cs.startdsr$.subscribe((datemonth) => {
      if (datemonth) {
        this.dsrmonth = datemonth;
      }
    });
    this.cs.product$.subscribe((code) => {
      if (code) {
        this.product = code;
      }
    });
  }

  triggerview() {
    if (this.show == 'Individual') {
      const user = JSON.parse(localStorage.getItem('user'))
      this.userrole = user.role
      if (this.userrole) {
        this.getros()
      }
      else {
        this.loaddash()
      }
      this.cds.markForCheck()
    }
    else {
      this.loaddash()
      this.cds.markForCheck()
    }
  }
  ngOnInit(): void {
    this.show = this.cs.reportsShow;
    this.roData = localStorage.getItem('loggedinro')
    const user = JSON.parse(localStorage.getItem('user'))
    this.userrole = user.role
    if (this.show == 'Individual') {
      const user = JSON.parse(localStorage.getItem('user'))
      this.userrole = user.role
      if (this.userrole) {
        this.getros()
      }
      else {
        this.loaddash()
      }
      this.cds.markForCheck()
    }
    else {
      this.loaddash()
      this.cds.markForCheck()
    }

  }

  getros() {
    // https://iomldev.digipetro.mycybercns.com/api/ro_master/ro_dropdown
    // let q = {"ro_code": this.roData.ro_code}
    this.cs.current({ 'tab': 'REPORTS', 'count': 0, 'showcount': true })
    this.baseService.doRequest(`/api/ro_master/ro_dropdown`, 'post', {}).subscribe((result: any) => {
      if (result && result.data && result.data.length > 0) {
        const user = JSON.parse(localStorage.getItem('user'))
        if (this.userrole.toLowerCase() !== 'superadmin' && this.userrole.toLowerCase() !== 'serveradmin' && this.userrole.toLowerCase() !== 'clientadmin' && this.userrole.toLowerCase() !== 'viewer') {
          if (user && user.ro_data && user.ro_data.length > 0) {
            this.rolist = result.data.filter(x => user.ro_data.includes(x.ro_code))
            this.codeh = JSON.parse(JSON.stringify(this.rolist))
            this.roData = this.codeh[0]
          }
        }
        else {
          this.rolist = []
          result.data.forEach(ele => {
            if (window.location.href.includes('bpcl') && (ele.ro_code == '169718' || ele.ro_code == '244802')) {
              this.rolist.push(ele)
            }
            else if (window.location.href.includes('ioml') && ele.ro_code !== '169718' && ele.ro_code !== '244802') {
              this.rolist.push(ele)
            }
            // this.rohash[ele.ro_code]=ele.ro_name
          })
          // this.rolist = result.data
          this.codeh = this.rolist
          this.roData = this.rolist[0]
        }
        this.cds.detectChanges()
        this.loaddash()
      }
    })

  }

  toggleAccordion(section) {
    const content = document.getElementById(`section${section}`);
    content.style.display = content.style.display === 'block' ? 'none' : 'block';
  }

  loaddash() {
    this.cs.current({ 'tab': 'REPORTS', 'count': 0, 'showcount': true })
    if (this.show === 'Individual') {
      if (this.cs.baseurl.includes('iocl')) {
        this.reportslist = [
          {
            'name': 'DU Transaction Data',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/121e3e00-81bc-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'DU%20TRANSACTION%20DATA%20-%20IOCL',viewMode:view)`
          },
          {
            'name': 'DU Totalizer Data',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/0bd5a7c0-9023-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'DU%20Totalizer%20Data%20-%20IOCL',viewMode:view)`
          },
          {
            'name': 'Inventory',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/725f1190-8f1d-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Inventory%20-%20IOCL',viewMode:view)`
          },
          {
            'name': 'Dispenser Reconciliation',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/d8dd17c0-8f2a-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Dispenser%20Reconciliation%20-%20IOCL',viewMode:view)`
          },

          {
            'name': 'Shift Daily Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/c88a19d0-ab5f-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Shift%20Daily%20Report',viewMode:view)`
          },
          {
            'name': 'Tank Nozzle Integration',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/5359bad0-b1e5-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-90d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_master_ref.ro_code.keyword:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'Tank%20Nozzle%20Integration',viewMode:view)`
          },
          {
            'name': 'RO Interlock Flag Status Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/038e1ff0-b1e0-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!t,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'RO%20Interlock%20Flag%20Status%20Report',viewMode:view)`
          },
          {
            'name': 'Tank & Nozzle Sales Comparison',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/26252f10-b1ed-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Tank%20%26%20Nozzle%20Sales%20Comparison',viewMode:view)`
          },
          {
            'name': 'Field Officer Inspection Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=iocl#/view/4645e2a0-b1dc-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:${this.roData.ro_code}),type:phrase),query:(match_phrase:(ro_code.keyword:${this.roData.ro_code})))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:FOIR,viewMode:view)`
          },
          {
            'name': 'Daily Sales Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=iocl#/view/4645e2a0-b1dc-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:${this.roData.ro_code}),type:phrase),query:(match_phrase:(ro_code.keyword:${this.roData.ro_code})))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:FOIR,viewMode:view)`
          },
          {
            'name': 'Hourly Wet Stock Sales Stats',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/a41e4360-ad02-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'Hourly%20Wet%20Stock%20Sales%20Stats',viewMode:view)`
          },
          {
            'name': 'Hourly Tank Stock',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/fc99de90-acf9-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'Hourly%20Tank%20Stock',viewMode:view)`
          },
          {
            'name': 'DSM Sales',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/8fea5120-acf0-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'DSM%20Sales',viewMode:view)`
          },
          {
            'name': 'Alerts',
            "link_report": `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/c8df38b0-7acd-11ed-b3e2-31cd40dcf1b3?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-30d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_master_ref.ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:Alerts,viewMode:view)`
          }
        ]
      }
      else {
        this.reportslist = [
          {
            'name': 'Traffic Report Dashboard',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/dc075600-c79b-11ed-983e-f16f1cb4cfb3?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-7d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:${this.roData.ro_code}),type:phrase),query:(match_phrase:(ro_code.keyword:${this.roData.ro_code})))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!t,title:'Traffic%20Report%20Dashboard',viewMode:view)`
          },

          {
            'name': 'DU Transaction Data',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/321ab490-ce06-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'DU%20TRANSACTION%20DATA%20-%20RO',viewMode:view)`
          },
          {
            'name': 'DU Totalizer Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/92aa2b90-cdf9-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'DU%20Totalizer%20Data%20-%20RO',viewMode:view)`
          },
          {
            'name': 'Daily Sales',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/c21c2a90-cdf9-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Daily%20Sales%20Report%20-%20RO',viewMode:view)`
          },
          // {'name':'Daily Sales Report',
          // 'link_report':`${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/c21c2a90-cdf9-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Daily%20Sales%20Report%20-%20RO',viewMode:view)`
          // },
          // {
          //   'name':'Daily Sales Report',
          //   'link_report':`${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/3cb51210-9026-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:'${this.roData.ro_code}'),type:phrase),query:(match_phrase:(ro_code.keyword:'${this.roData.ro_code}')))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:'Daily%20Sales%20Report',viewMode:view)`
          // },
          // {
          //   'name':'Daily Sales',
          //   'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/c21c2a90-cdf9-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Daily%20Sales%20Report%20-%20RO',viewMode:view)`
          // },
          {
            'name': 'Tank Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/725f1190-8f1d-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'6552be60-8cee-11ed-9f18-57ead4f70fcc',key:ro_code.keyword,negate:!f,params:(query:'${this.roData.ro_code}'),type:phrase),query:(match_phrase:(ro_code.keyword:'${this.roData.ro_code}')))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:'Inventory%20-%20IOML',viewMode:view)`
          },
          {
            'name': 'Reconciliation report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/e8ffc360-cdf9-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Dispenser%20Reconciliation%20-%20RO',viewMode:view)`
          },
          {
            'name': 'Daily Shift Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/ecd151e0-ce06-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Shift%20Daily%20Report%20-%20RO',viewMode:view)`

          },
          {
            'name': 'Tank Nozzle Integration',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/5359bad0-b1e5-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-90d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:c41a8190-7794-11ed-a855-c745e5122281,key:ro_master_ref.ro_code.keyword,negate:!f,params:(query:'${this.roData.ro_code}'),type:phrase),query:(match_phrase:(ro_master_ref.ro_code.keyword:'${this.roData.ro_code}')))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!t,title:'Tank%20Nozzle%20Integration',viewMode:view)`
          },
          {
            'name': 'RO Interlock Flag Status Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/038e1ff0-b1e0-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:'${this.roData.ro_code}'),type:phrase),query:(match_phrase:(ro_code.keyword:'${this.roData.ro_code}')))),fullScreenMode:!f,options:(hidePanelTitles:!t,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:'RO%20Interlock%20Flag%20Status%20Report',viewMode:view)`
          },
          {
            'name': 'Tank & Nozzle Sales Comparison',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/26252f10-b1ed-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:'${this.roData.ro_code}'),type:phrase),query:(match_phrase:(ro_code.keyword:'${this.roData.ro_code}')))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!t,title:'Tank%20%26%20Nozzle%20Sales%20Comparison',viewMode:view)`
          },
          {
            'name': 'Field Officer Inspection Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/4645e2a0-b1dc-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:'${this.roData.ro_code}'),type:phrase),query:(match_phrase:(ro_code.keyword:'${this.roData.ro_code}')))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:FOIR,viewMode:view)`
          },
          {
            'name': 'Daily Sales Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=iocl#/view/4645e2a0-b1dc-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:${this.roData.ro_code}),type:phrase),query:(match_phrase:(ro_code.keyword:${this.roData.ro_code})))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:FOIR,viewMode:view)`
          },
          {
            'name': 'Hourly Wet Stock Sales Stats',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/bf94c6f0-cdfa-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'Hourly%20Wet%20Stock%20Sales%20Stats%20-%20RO',viewMode:view)`
          },
          {
            'name': 'Hourly Tank Stock',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/a40013e0-cdfa-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'Hourly%20Tank%20Stock%20-%20RO',viewMode:view)`
          },
          {
            'name': 'DSM Sales',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/af522ac0-cdf6-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'DSM%20Sales%20-%20RO',viewMode:view)`
          },
          // {
          //   'name':'Traffic Report Dashboard',
          //   'link_report':`${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/e52d0c70-c796-11ed-983e-f16f1cb4cfb3?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-7d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:'RO%20Performance%20Dashboard',viewMode:view)`
          // },
          {
            'name': 'Alerts',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/c8df38b0-7acd-11ed-b3e2-31cd40dcf1b3?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-2d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_master_ref.ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:Alerts,viewMode:view)`
          },
          {
            'name': 'Traffic Report Dashboard',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/dc075600-c79b-11ed-983e-f16f1cb4cfb3?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-7d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:${this.roData.ro_code}),type:phrase),query:(match_phrase:(ro_code.keyword:${this.roData.ro_code})))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!t,title:'Traffic%20Report%20Dashboard',viewMode:view)`
          },
          {
            'name': "RFID Sales Analysis",
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=ioml#/view/b125e610-12bb-11ef-8a8f-0748a234c187?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-1d,to:now))&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:a4d55db0-5b72-11ee-8d9a-dd67c1ca1fda,key:ro_code.keyword,negate:!f,params:(query:${this.roData.ro_code}),type:phrase),query:(match_phrase:(ro_code.keyword:${this.roData.ro_code})))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:'rfid%20sales%20dashboard',viewMode:view)&show-time-filter=true&hide-filter-bar=true`
          }
          // {
          //   'name':'test',
          //   "link_report":`${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/121e3e00-81bc-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-2d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'DU%20TRANSACTION%20DATA%20-%20IOML',viewMode:view)`
          // }
        ]
        if (this.userrole.toLowerCase().includes('admin')) {
          this.reportslist.push({
            'name': 'IOML Stock Reconciliation',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=ioml#/view/6a6c55e0-c57e-11ee-8a8f-0748a234c187?embed=true&_g=(filters:!(),query:(language:kuery,query:''),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:Inventory,viewMode:view)&hide-top-menu=true&hide-query-input=true&show-time-filter=true&hide-filter-bar=true`
          })
          this.reportslist.push({
            'name': 'Device Status',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=ioml#/view/385424b0-103e-11ef-8a8f-0748a234c187?embed=true&_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3A'2024-04-30T18%3A30%3A00.000Z'%2Cto%3Anow-1d))&show-time-filter=true&hide-filter-bar=true`
          }),
            this.reportslist.push({
              'name': 'Sales Analisis',
              'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=ioml#/view/ab597750-1050-11ef-8a8f-0748a234c187?embed=true&_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3A'2024-04-30T18%3A30%3A00.000Z'%2Cto%3Anow-1d))&show-time-filter=true&hide-filter-bar=true`
            })
        }
      }
    } else {
      if (this.cs.baseurl.includes('iocl')) {
        this.reportslist = [
          {
            'name': 'Retail Outlet',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=iocl#/view/14c78140-39ce-11ef-b585-7b1e82f86fd8?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-1y,to:now))&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!t,title:'RO%20Details',viewMode:view)&hide-top-menu=true&hide-query-input=true&show-time-filter=true&hide-filter-bar=true`
          },
          // {
          //   'name': 'Summary',
          //   'link_report': `${this.cs.kibanaurl}/kibana/app/dashboards?security_tenant=ioml#/view/713295a0-2561-11ee-a66e-93780261916c?embed=true&_g=(filters:!(),query:(language:kuery,query:''),refreshInterval:(pause:!t,value:0),time:(from:now-7d,to:now))&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!f),query:(language:kuery,query:''),timeRestore:!t,title:'Summary%20Dashboard%20',viewMode:view)&hide-top-menu=true&hide-query-input=true&show-time-filter=true&hide-filter-bar=true`
          // },
        ]
      } else {
        this.reportslist = [
          {
            'name': 'Retail Outlet',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=ioml#/view/08192b30-39d1-11ef-8a8f-0748a234c187?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-3y,to:now))&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!t,title:'RO%20Details',viewMode:view)&hide-top-menu=true&hide-query-input=true&show-time-filter=true&hide-filter-bar=true`
          },
          {
            'name': 'Summary',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=ioml#/view/713295a0-2561-11ee-a66e-93780261916c?embed=true&_g=(filters:!(),query:(language:kuery,query:''),refreshInterval:(pause:!t,value:0),time:(from:now-7d,to:now))&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!f),query:(language:kuery,query:''),timeRestore:!t,title:'Summary%20Dashboard%20',viewMode:view)&hide-top-menu=true&hide-query-input=true&show-time-filter=true&hide-filter-bar=true`
          },
        ]
      }
    }
    this.codei = this.reportslist
    this.currentreport = this.reportslist[0]
    this.cds.detectChanges()
    this.selectreport(this.currentreport.link_report)
  }

  reloadrepo() {
    if (this.show === 'Individual') {
      if (this.cs.baseurl.includes('iocl')) {
        this.reportslist = [
          {
            'name': 'DU Transaction Data',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/121e3e00-81bc-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'DU%20TRANSACTION%20DATA%20-%20IOCL',viewMode:view)`
          },
          {
            'name': 'DU Totalizer Data',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/0bd5a7c0-9023-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'DU%20Totalizer%20Data%20-%20IOCL',viewMode:view)`
          },
          {
            'name': 'Inventory',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/725f1190-8f1d-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Inventory%20-%20IOCL',viewMode:view)`
          },
          {
            'name': 'Dispenser Reconciliation',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/d8dd17c0-8f2a-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Dispenser%20Reconciliation%20-%20IOCL',viewMode:view)`
          },
          {
            'name': 'Shift Daily Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/c88a19d0-ab5f-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Shift%20Daily%20Report',viewMode:view)`
          },
          {
            'name': 'Tank Nozzle Integration',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/5359bad0-b1e5-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-90d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_master_ref.ro_code.keyword:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'Tank%20Nozzle%20Integration',viewMode:view)`
          },
          {
            'name': 'RO Interlock Flag Status Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/038e1ff0-b1e0-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!t,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'RO%20Interlock%20Flag%20Status%20Report',viewMode:view)`
          },
          {
            'name': 'Tank & Nozzle Sales Comparison',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/26252f10-b1ed-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Tank%20%26%20Nozzle%20Sales%20Comparison',viewMode:view)`
          },
          {
            'name': 'Field Officer Inspection Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=iocl#/view/4645e2a0-b1dc-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:${this.roData.ro_code}),type:phrase),query:(match_phrase:(ro_code.keyword:${this.roData.ro_code})))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:FOIR,viewMode:view)`
          },
          {
            'name': 'Daily Sales Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=iocl#/view/4645e2a0-b1dc-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:${this.roData.ro_code}),type:phrase),query:(match_phrase:(ro_code.keyword:${this.roData.ro_code})))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:FOIR,viewMode:view)`
          },
          {
            'name': 'Hourly Wet Stock Sales Stats',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/a41e4360-ad02-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'Hourly%20Wet%20Stock%20Sales%20Stats',viewMode:view)`
          },
          {
            'name': 'Hourly Tank Stock',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/fc99de90-acf9-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'Hourly%20Tank%20Stock',viewMode:view)`
          },
          {
            'name': 'DSM Sales',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/8fea5120-acf0-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'DSM%20Sales',viewMode:view)`
          },
          {
            'name': 'Alerts',
            "link_report": `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/c8df38b0-7acd-11ed-b3e2-31cd40dcf1b3?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-30d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_master_ref.ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:Alerts,viewMode:view)`
          }
        ]
      } else {
        this.reportslist = [
          {
            'name': 'Summary',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=ioml#/view/c0a4d3a0-05ae-11ee-8e4b-4d69b5eb1701?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-7d,to:now))&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!f),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'Daily%20Summary%20Dashboard%20-%20RO',viewMode:view)&hide-top-menu=true&hide-query-input=true&show-time-filter=true&hide-filter-bar=true`
          },
          // {
          //   'name':"Overview dashboard",
          //   'link_report':`${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/5eae7f60-cdf1-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-2d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:${this.roData.ro_code}),type:phrase),query:(match_phrase:(ro_code.keyword:${this.roData.ro_code})))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!f),query:(language:kuery,query:''),timeRestore:!t,title:'OVERVIEW%20Sales%20Dashboard%20-%20RO',viewMode:view)`
          // },
          {
            'name': 'DU Transaction Data',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/321ab490-ce06-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'DU%20TRANSACTION%20DATA%20-%20RO',viewMode:view)`
          },
          {
            'name': 'Daily Sales',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/c21c2a90-cdf9-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Daily%20Sales%20Report%20-%20RO',viewMode:view)`
          },
          {
            'name': 'DU Totalizer Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/92aa2b90-cdf9-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'DU%20Totalizer%20Data%20-%20RO',viewMode:view)`
          },
          {
            'name': 'Tank Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/725f1190-8f1d-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'6552be60-8cee-11ed-9f18-57ead4f70fcc',key:ro_code.keyword,negate:!f,params:(query:'${this.roData.ro_code}'),type:phrase),query:(match_phrase:(ro_code.keyword:'${this.roData.ro_code}')))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:'Inventory%20-%20IOML',viewMode:view)`
          },
          {
            'name': 'Reconciliation report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/e8ffc360-cdf9-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Dispenser%20Reconciliation%20-%20RO',viewMode:view)`
          },
          {
            'name': 'Daily Shift Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/ecd151e0-ce06-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:'Shift%20Daily%20Report%20-%20RO',viewMode:view)`

          },
          {
            'name': 'Tank Nozzle Integration',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/5359bad0-b1e5-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-90d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:c41a8190-7794-11ed-a855-c745e5122281,key:ro_master_ref.ro_code.keyword,negate:!f,params:(query:'${this.roData.ro_code}'),type:phrase),query:(match_phrase:(ro_master_ref.ro_code.keyword:'${this.roData.ro_code}')))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!t,title:'Tank%20Nozzle%20Integration',viewMode:view)`
          },
          {
            'name': 'RO Interlock Flag Status Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/038e1ff0-b1e0-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:'${this.roData.ro_code}'),type:phrase),query:(match_phrase:(ro_code.keyword:'${this.roData.ro_code}')))),fullScreenMode:!f,options:(hidePanelTitles:!t,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:'RO%20Interlock%20Flag%20Status%20Report',viewMode:view)`
          },
          {
            'name': 'Tank & Nozzle Sales Comparison',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/26252f10-b1ed-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:'${this.roData.ro_code}'),type:phrase),query:(match_phrase:(ro_code.keyword:'${this.roData.ro_code}')))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!t,title:'Tank%20%26%20Nozzle%20Sales%20Comparison',viewMode:view)`
          },
          {
            'name': 'Field Officer Inspection Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/4645e2a0-b1dc-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:'${this.roData.ro_code}'),type:phrase),query:(match_phrase:(ro_code.keyword:'${this.roData.ro_code}')))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:FOIR,viewMode:view)`
          },
          {
            'name': 'Daily Sales Report',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=iocl#/view/4645e2a0-b1dc-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:${this.roData.ro_code}),type:phrase),query:(match_phrase:(ro_code.keyword:${this.roData.ro_code})))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:FOIR,viewMode:view)`
          },
          {
            'name': 'Hourly Wet Stock Sales Stats',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/bf94c6f0-cdfa-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'Hourly%20Wet%20Stock%20Sales%20Stats%20-%20RO',viewMode:view)`
          },
          {
            'name': 'Hourly Tank Stock',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/a40013e0-cdfa-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'Hourly%20Tank%20Stock%20-%20RO',viewMode:view)`
          },
          {
            'name': 'DSM Sales',
            // 'link_report':`${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/8fea5120-acf0-11ed-9f18-57ead4f70fcc?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'DSM%20Sales%20-%20Admin',viewMode:view)`
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/af522ac0-cdf6-11ed-b1a8-1732229ff00e?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!t,title:'DSM%20Sales%20-%20RO',viewMode:view)`
          },
          {
            'name': 'Alerts',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/c8df38b0-7acd-11ed-b3e2-31cd40dcf1b3?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-2d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:'ro_master_ref.ro_code:%20%22${this.roData.ro_code}%22'),timeRestore:!f,title:Alerts,viewMode:view)`
          },
          {
            'name': 'Traffic Report Dashboard',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=global#/view/dc075600-c79b-11ed-983e-f16f1cb4cfb3?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-7d,to:now))&show-time-filter=true&hide-filter-bar=true&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'280b38b0-6b16-11ed-a749-3d3019a18890',key:ro_code.keyword,negate:!f,params:(query:${this.roData.ro_code}),type:phrase),query:(match_phrase:(ro_code.keyword:${this.roData.ro_code})))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!t,title:'Traffic%20Report%20Dashboard',viewMode:view)`
          },
          {
            'name': "RFID Sales Analysis",
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=ioml#/view/b125e610-12bb-11ef-8a8f-0748a234c187?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-1d,to:now))&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:a4d55db0-5b72-11ee-8d9a-dd67c1ca1fda,key:ro_code.keyword,negate:!f,params:(query:${this.roData.ro_code}),type:phrase),query:(match_phrase:(ro_code.keyword:${this.roData.ro_code})))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:'rfid%20sales%20dashboard',viewMode:view)&show-time-filter=true&hide-filter-bar=true`
          }

        ]
        if (this.userrole.toLowerCase().includes('admin')) {
          this.reportslist.push({
            'name': 'IOML Stock Reconciliation',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=ioml#/view/6a6c55e0-c57e-11ee-8a8f-0748a234c187?embed=true&_g=(filters:!(),query:(language:kuery,query:''),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:Inventory,viewMode:view)&hide-top-menu=true&hide-query-input=true&show-time-filter=true&hide-filter-bar=true`
          })
          this.reportslist.push({
            'name': 'Device Status',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=ioml#/view/385424b0-103e-11ef-8a8f-0748a234c187?embed=true&_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3A'2024-04-30T18%3A30%3A00.000Z'%2Cto%3Anow-1d))&show-time-filter=true&hide-filter-bar=true`
          })
          this.reportslist.push({
            'name': 'Sales Analisis',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=ioml#/view/ab597750-1050-11ef-8a8f-0748a234c187?embed=true&_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3A'2024-04-30T18%3A30%3A00.000Z'%2Cto%3Anow-1d))&show-time-filter=true&hide-filter-bar=true`
          })


        }
      }
    } else {
      if (this.cs.baseurl.includes('iocl')) {
        this.reportslist = [
          {
            'name': 'Retail Outlet',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=iocl#/view/14c78140-39ce-11ef-b585-7b1e82f86fd8?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-1y,to:now))&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!t,title:'RO%20Details',viewMode:view)&hide-top-menu=true&hide-query-input=true&show-time-filter=true&hide-filter-bar=true`
          },
          // {
          //   'name': 'Summary',
          //   'link_report': `${this.cs.kibanaurl}/kibana/app/dashboards?security_tenant=ioml#/view/713295a0-2561-11ee-a66e-93780261916c?embed=true&_g=(filters:!(),query:(language:kuery,query:''),refreshInterval:(pause:!t,value:0),time:(from:now-7d,to:now))&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!f),query:(language:kuery,query:''),timeRestore:!t,title:'Summary%20Dashboard%20',viewMode:view)&hide-top-menu=true&hide-query-input=true&show-time-filter=true&hide-filter-bar=true`
          // },
        ]
      } else {
        this.reportslist = [
          {
            'name': 'Retail Outlet',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=ioml#/view/08192b30-39d1-11ef-8a8f-0748a234c187?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-3y,to:now))&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!t,title:'RO%20Details',viewMode:view)&hide-top-menu=true&hide-query-input=true&show-time-filter=true&hide-filter-bar=true`
          },
          {
            'name': 'Summary',
            'link_report': `${this.cs.baseurl}/kibana/app/dashboards?security_tenant=ioml#/view/713295a0-2561-11ee-a66e-93780261916c?embed=true&_g=(filters:!(),query:(language:kuery,query:''),refreshInterval:(pause:!t,value:0),time:(from:now-7d,to:now))&_a=(description:'',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!f),query:(language:kuery,query:''),timeRestore:!t,title:'Summary%20Dashboard%20',viewMode:view)&hide-top-menu=true&hide-query-input=true&show-time-filter=true&hide-filter-bar=true`
          },
        ]
      }
    }
    this.cds.detectChanges()
  }

  selectreport(repo) {

    const ro = Number(localStorage.getItem('loggedinro'))
    const httpOptions = new HttpHeaders()
      .set('osd-xsrf', 'true')
    var kibanaurl = ''
    const redirect_uri = `${this.cs.baseurl}/kibana/auth/login`

    const URL = redirect_uri
    const browseUrl = kibanaurl
    if (window.location.href.includes('iocldev')) {
      var creds = { username: 'digitalpetro', password: '@Digital2024' }
    }
    else if (window.location.href.includes('iomldev')) {
      creds = { username: 'digitalpetro', password: '@Digital2024' }
    }
    else {
      creds = { username: 'digitalpetro', password: '@Digital2024' }
    }
    this.loadingreports = true;
    this.cds.detectChanges()
    this.httpClient.post(URL, creds, { headers: httpOptions }).subscribe((data: any) => {
      setTimeout(() => {
        setTimeout(() => {
          this.loadingreports = false;
          this.urlSafe1 = this.sanitizer.bypassSecurityTrustResourceUrl(`${repo}`)
          this.load = true;
        }, 1000);
      }, 6000);
    }, error => {
      this.loadingreports = false;
    })
  }


  changerepo(event, repo) {
    if (repo.name !== 'Field Officer Inspection Report' && this.currentreport.name !== 'Daily Sales Report' && this.currentreport.name !== 'Tank & Nozzle Sales Comparison') {
      this.urlSafe1 = this.sanitizer.bypassSecurityTrustResourceUrl(`${repo.link_report}`)
    }

  }

  changero(event, ro) {
    this.load = false;
    this.reloadrepo()
    setTimeout(() => {
      if (this.currentreport.name !== 'Field Officer Inspection Report' && this.currentreport.name !== 'Daily Sales Report' && this.currentreport.name !== 'Tank & Nozzle Sales Comparison') {
        const temp = this.reportslist.filter(x => x.name == this.currentreport.name)
        this.currentreport = temp[0]
        this.urlSafe1 = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.currentreport.link_report}`)
      }
      this.load = true
    }, 2000);
  }

  // downloadDivAsPdf() {
  //   const element = document.getElementById('downloadReports'); // Replace 'divToDownload' with the ID of your target <div> element

  //   html2pdf().from(element).save('Report.pdf');
  // }

  downloadPageAsPdf() {
    const element = document.getElementById('downloadReports'); // Replace 'divToDownload' with the ID of your target <div> element

    const pdf = new jsPDF();
    pdf.html(element, {
      callback: () => {
        pdf.save('Report.pdf');
      }
    });
  }

  //  downloadDivAsPdf() {
  //   const element = document.getElementById('downloadReports');  // Capture the entire page

  //   html2canvas(element).then((canvas) => {
  //     const imgData = canvas.toDataURL('image/png');

  //     // Set the PDF dimensions to match the captured content
  //     const pdf = new jsPDF({
  //       orientation: 'portrait',
  //       unit: 'px',
  //       format: 'a4'
  //     });

  //     const imgProps = pdf.getImageProperties(imgData);
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  //     const pdfheight = pdf.internal.pageSize.getHeight();

  //     // Add the image to the PDF and adjust the dimensions
  //     pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfheight);

  //     // Initiate the download of the PDF file
  //     pdf.save('page_content.pdf');
  //   });
  // }


  // downloadDivAsPdf() {
  //   var element:any;
  //   if(this.currentreport && this.currentreport.name === 'Field Officer Inspection Report'){
  //   element = document.getElementById('downloadReportsfoir');} // Replace 'downloadReports' with the ID or selector of the div you want to download
  //   else{
  //     element = document.getElementById('downloadReportsdsr')
  //   }
  //   const options = {
  //     scrollY: -window.scrollY,
  //     scrollx: -window.scrollX, // Capture the entire scrollable area
  //     scale: 2, // Increase the scale if needed for better resolution
  //     backgroundColor: '#ffffff' // Set the desired background color of the captured area
  //   };


  //   html2canvas(element, options).then((canvas) => {
  //     const imgData = canvas.toDataURL('image/png');

  //     // Set the PDF dimensions to match the captured content
  //     const imgWidth = canvas.width;
  //     const imgHeight = canvas.height;
  //     const canvasWidth = element.scrollWidth;
  //     const pdf = new jsPDF({
  //       orientation: imgWidth > imgHeight ? 'landscape' : 'portrait',
  //       unit: 'px',
  //       format: [canvasWidth, imgHeight]
  //     });

  //     // const imgWidth = pdf.internal.pageSize.getWidth();
  //     // const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     // Add the image to the PDF and adjust the dimensions
  //     pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

  //     // Initiate the download of the PDF file
  //     setTimeout(() => {
  //       pdf.save(`FOIR_Report.pdf`);
  //     }, 10000);
  //   });
  // }

  // downloadDivAsPdf() {
  //   if (this.currentreport.name === 'Field Officer Inspection Report' || this.currentreport.name === "Tank & Nozzle Sales Comparison") {
  //     const element = this.currentreport && (this.currentreport.name === 'Field Officer Inspection Report'|| this.currentreport.name === "Tank & Nozzle Sales Comparison")
  //       ? document.getElementById('downloadReportsfoir')
  //       : document.getElementById('downloadReportsdsr');

  //     const options = {
  //       scrollY: -window.scrollY,
  //       scale: 2,
  //       backgroundColor: '#ffffff'
  //     };
  //     this.loadingreports = true
  //     this.cds.detectChanges()
  //     html2canvas(element, options).then((canvas) => {
  //       const imgData = canvas.toDataURL('image/png');

  //       const imgWidth = canvas.width;
  //       const imgHeight = canvas.height;
  //       const canvasWidth = element.scrollWidth;

  //       const pdf = new jsPDF({
  //         orientation: imgWidth > imgHeight ? 'landscape' : 'portrait',
  //         unit: 'px',
  //         format: [imgWidth, imgHeight]
  //       });

  //       pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
  //       pdf.text(this.roData.ro_code, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() / 2, { align: 'center' }, 45);
  //       if (this.currentreport.name === 'Field Officer Inspection Report') {
  //         pdf.save(`FOIR_Report.pdf`);
  //         this.loadingreports = false
  //       }else if(this.currentreport.name === "Tank & Nozzle Sales Comparison"){
  //         pdf.save(`Tank & Nozzle Sales Comparison.pdf`);
  //         this.loadingreports = false
  //       }
  //       else {
  //         pdf.save(`DSR_Report.pdf`);
  //         this.loadingreports = false

  //       }
  //     });
  //   }
  //   else {
  //     this.downloadDivAsPdfnewtt()
  //   }

  // }
  downloadDivAsPdf() {
    this.isChildHidden = true; // Hides the child button
    // Check for valid report names
    if (this.currentreport.name === 'Field Officer Inspection Report' || this.currentreport.name === 'Tank & Nozzle Sales Comparison') {

      // const element = this.currentreport.name === 'Field Officer Inspection Report'
      //   ? document.getElementById('downloadReportsfoir')
      //   : document.getElementById('downloadReportsdsr');
      let element;
      if (this.currentreport.name === 'Field Officer Inspection Report') {
        element= document.getElementById('downloadReportsfoir')
      } else if (this.currentreport.name === 'Tank & Nozzle Sales Comparison') {
        element= document.getElementById('downloadReportsfoirtank');
      } else {
        element= document.getElementById('downloadReportsdsr');
      }
      // Ensure the element exists
      if (!element) {
        console.error('Element not found');
        return;
      }


      const options = {
        scrollY: -window.scrollY,
        // scrollx: -window.scrollX,
        // scrollY: -window.scrollY, // Adjust scroll position
        scale: 2, // Lower scale for smaller file size
        backgroundColor: '#ffffff' // Ensure white background
      };

      this.loadingreports = true;
      this.cds.detectChanges(); // Detect changes to ensure element is rendered

      html2canvas(element, options).then((canvas) => {
        const imgData = canvas.toDataURL('image/jpeg', 0.7); // JPEG format with compression
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const canvasWidth = element.scrollWidth;

        const pdf = new jsPDF({
          orientation: imgWidth > imgHeight ? 'landscape' : 'portrait',
          unit: 'px',
          format: [imgWidth, imgHeight]
        });

        // Add image to PDF
        pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);

        // Add centered text
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        pdf.text(
          this.roData.ro_code,
          pageWidth / 2,
          pageHeight - 10, // Slightly above the bottom edge
          { align: 'center' }
        );


        // Save the PDF with appropriate file name
        const fileName = this.currentreport.name === 'Field Officer Inspection Report'
          ? `FOIR_${this.roData.ro_name} ${this.startDateMoment}.pdf`
          : 'Tank & Nozzle Sales Comparison.pdf';
        pdf.save(fileName);

        this.isChildHidden = false;
        this.loadingreports = false;
        this.cds.detectChanges();

        // Reset loading indicator
      }).catch((error) => {
        console.error('Error generating PDF:', error);
        this.loadingreports = false;
      });
    } else {
      // Handle other cases
      this.downloadDivAsPdfnewtt();
    }
  }

  // downloadDivAsPdfnewtt() {

  //   // const divElement = document.getElementById('dsrreportdatain');
  //   var divElement = document.getElementById('dsrreportdatain');
  //   divElement.scrollTop = 0;

  //   this.loadingreports = true
  //   html2canvas(divElement).then((canvas) => {
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //     pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);


  //     const overlayContainer = document.createElement('div');
  //     overlayContainer.style.position = 'absolute';
  //     overlayContainer.style.top = '0';
  //     overlayContainer.style.opacity = '0.5'
  //     overlayContainer.style.left = '0';
  //     overlayContainer.style.width = `${pdfWidth}px`;
  //     overlayContainer.style.height = `${pdfHeight}px`;

  //     const overlayData = new XMLSerializer().serializeToString(overlayContainer);

  //     pdf.html(overlayData, {
  //       callback: () => {
  //         pdf.save('DSR_Report.pdf');

  //         overlayContainer.remove();
  //         this.loadingreports = false
  //       },
  //     });
  //   });
  // }

  // downloadDivAsPdfnewtt() {
  //   const divElement = document.getElementById('dsrreportdatain');
  //   const initialScrollTop = divElement.scrollTop;
  //   const scrol = document.getElementById('isscrolled')
  //   // Scroll the table to the top
  //   divElement.scrollTo(0, 0);

  //   this.loadingreports = true;
  //   html2canvas(divElement).then((canvas) => {
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //     pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

  //     const overlayContainer = document.createElement('div');
  //     overlayContainer.style.position = 'absolute';
  //     overlayContainer.style.top = '0';
  //     overlayContainer.style.opacity = '0.5';
  //     overlayContainer.style.left = '0';
  //     overlayContainer.style.width = `${pdfWidth}px`;
  //     overlayContainer.style.height = `${pdfHeight}px`;

  //     const overlayData = new XMLSerializer().serializeToString(overlayContainer);

  //     pdf.html(overlayData, {
  //       callback: () => {
  //         pdf.save('DSR_Report.pdf');

  //         // Scroll back to the initial position after generating the PDF
  //         divElement.scrollTo(0, initialScrollTop);

  //         overlayContainer.remove();
  //         this.loadingreports = false;
  //       },
  //     });
  //   });
  // }


  downloadDivAsPdfnewtt() {
    this.isChildHidden = true;
    const divElements = document.getElementById('dsrreportdatain');
    const initialScrollTop = divElements.scrollTop;
    const hiddenRows = divElements.querySelectorAll('tr[style="display: none;"]');
    hiddenRows.forEach((row: any) => row.style.display = '');
    divElements.scrollTo(0, 0);
    // const divElement = document.getElementById('dsrreportdatainx');
    this.loadingreports = true;
    this.cds.detectChanges()
    const div1 = document.getElementById('dsrreportdata'); // First div
    const div2 = document.getElementById('dsrreportdatainx'); // Second div

    this.loadingreports = true;
    this.cds.detectChanges();

    // Capture first div
    html2canvas(div1).then((canvas1) => {
      const imgData1 = canvas1.toDataURL('image/png');

      // Capture second div
      html2canvas(div2).then((canvas2) => {
        const imgData2 = canvas2.toDataURL('image/png');

        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        // Calculate heights
        const imgHeight1 = (canvas1.height * pdfWidth) / canvas1.width;
        const imgHeight2 = (canvas2.height * pdfWidth) / canvas2.width;
        let yPos = 0; // Start position for first image
        pdf.addImage(imgData1, 'PNG', 0, yPos, pdfWidth, imgHeight1);
        yPos += imgHeight1; // Move to next position
        pdf.addImage(imgData2, 'PNG', 0, yPos, pdfWidth, imgHeight2);
        pdf.save(`DSR_${this.product} ${this.dsrmonth} ${this.roData.ro_name}.pdf`);
        // Restore hidden rows and scroll position
        hiddenRows.forEach((row: any) => row.style.display = 'none');
        divElements.scrollTo(0, initialScrollTop);
        this.isChildHidden = false
        this.loadingreports = false;
        this.cds.detectChanges();
      });
    });


    // html2canvas(divElement).then((canvas) => {
    //   const imgData = canvas.toDataURL('image/png');
    //   const pdf = new jsPDF('p', 'mm', 'a4');
    //   const pdfWidth = pdf.internal.pageSize.getWidth();
    //   const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    //   pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

    //   const overlayContainer = document.createElement('div');
    //   overlayContainer.style.position = 'absolute';
    //   overlayContainer.style.top = '70px'; // Adjust the value based on your header height
    //   overlayContainer.style.opacity = '0.5';
    //   overlayContainer.style.left = '0';
    //   overlayContainer.style.width = `${pdfWidth}px`;
    //   overlayContainer.style.height = `${pdfHeight}px`;

    //   const overlayData = new XMLSerializer().serializeToString(overlayContainer);

    //   pdf.html(overlayData, {
    //     callback: () => {
    //       pdf.save(`DSR_${this.product} ${this.dsrmonth} ${this.roData.ro_name}.pdf`);

    //       // Hide the rows again
    //       hiddenRows.forEach((row: any) => row.style.display = 'none');

    //       // Scroll back to the initial position after generating the PDF
    //       divElement.scrollTo(0, initialScrollTop);

    //       overlayContainer.remove();
    //       this.loadingreports = false;
    //     },
    //   });
    // }

    // );
  }


}
